// components/ChatBox.jsx
import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { generateVisitorId } from '../utils';
import TypingIndicator from "./TypingIndicator";
import bubble from "../assets/images/bubble.png";
import a5 from "../assets/images/a5.png";
import Scroller from "./Scroller";
import MarkdownTyper from "./MarkdownTyper";
import { CloseButton, Image } from "react-bootstrap";
import { introPrompt, initSystemPrompt } from "../utils";

function ChatBox({ className, onClose }) {
  const navigate = useNavigate();

  const [query, setQuery] = useState("");
  const [messages, setMessages] = useState([]);
  const [isTyping, setIsTyping] = useState(false);
  const [autoMessageIndex, setAutoMessageIndex] = useState(0);

  const autoMessages = useMemo(() => [
    introPrompt,
    initSystemPrompt,
  ], []);

  useEffect(() => {
    sessionStorage.removeItem("modules");
    if (autoMessageIndex < autoMessages.length) {
      setIsTyping(true);

      const typingTimer = setTimeout(() => {
        setIsTyping(false);
        setMessages(prev => [...prev, {
          isBot: true,
          text: autoMessages[autoMessageIndex],
        }]);

        const nextMessageTimer = setTimeout(() => {
          setAutoMessageIndex(prev => prev + 1);
        }, 1500);

        return () => clearTimeout(nextMessageTimer);
      }, 2000);

      return () => clearTimeout(typingTimer);
    }
  }, [autoMessageIndex, autoMessages]);

  const onSendMessage = () => {
    if (!query.trim()) return;

    const prompt = query
    const newMessage = {
      text: prompt,
      isBot: false,
    };

    setQuery('');
    generateVisitorId();
    setMessages(prev => [...prev, newMessage]);
    sessionStorage.setItem("initPrompt", prompt);
    navigate('/onboard/story');
  };

  const handleKeyUp = (e) => {
    if ((e.ctrlKey || e.metaKey) && e.key === 'Enter') {
      e.preventDefault();
      setQuery((prevText) => prevText + '\n');
    } else if ((e.shiftKey || e.metaKey) && e.key === 'Enter') {
      e.preventDefault();
    } else if (e.key === 'Enter') {
      onSendMessage();
    }
  };

  const handleChange = (e) => {
    setQuery(e.target.value);
  };

  return (
    <div className={`chat-box ${className}`}>
      <div className="chat-header">
        <div className="d-flex align-items-center justify-content-center rounded-circle">
          <Image src={bubble} alt="SwiftDeploy AI" width={24} height={24} />
          <h6 className="mb-0 fw-semibold ms-2">From Idea to App. In less than 10 minutes</h6>
        </div>
        {onClose && (
          <CloseButton onClick={onClose} />
        )}
      </div>
      <Scroller className="chat-body">
        {messages.map((message, index) => (
          <div key={index} className={`d-flex justify-content-${message.isBot ? 'start' : 'end'} mb-3`}>
            {message.isBot && (
              <Image src={a5} alt="Kumar" width={30} height={30} className="rounded-pill me-2" />
            )}
            <div className={`bubble ${message.isBot ? '' : 'user-bubble'}`}>
              {message.isBot ? (
                <MarkdownTyper text={message.text} />
              ) : (
                <p className="mb-0">{message.text}</p>
              )}
            </div>
          </div>
        ))}

        {isTyping && (
          <div className="d-flex justify-content-start mb-3">
            <Image src={a5} alt="Kumar" width={30} height={30} className="rounded-pill me-2" />
            <TypingIndicator />
          </div>
        )}
      </Scroller>
      <div className="bg-white p-4">
        <div className="position-relative chat-input home-chat-input shadow-none">
          <textarea
            value={query}
            onKeyUp={handleKeyUp}
            placeholder="Ask AI something..."
            onChange={handleChange}></textarea>
          <button
            onClick={onSendMessage}
            disabled={!query.trim()}
            className="send-btn home-send-btn"
          >
            <i className="icon-arrow-up"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChatBox;